import { useState } from "react";
import type { ProductionCompletionCheck } from "../models";
import type { machineCountLabel } from "../live-counter";
import { TouchSheet as Sheet } from "../TouchSheet";
import { completionCheckRows } from "./completion-check-view-model";

export function CompletionCheckSheet({ check, unit, machineUnit, saving, close, submit }: {
  check: ProductionCompletionCheck;
  unit: string;
  machineUnit: ReturnType<typeof machineCountLabel>;
  saving: boolean;
  close: () => void;
  submit: (reason: string) => Promise<unknown>;
}) {
  const [reason, setReason] = useState("");
  const rows = completionCheckRows(check, unit, machineUnit);
  return <Sheet title="Tamamlama kontrolü" close={close}>
    <div className="touch-form completion-check-form">
      <p>Sunucudaki güncel üretim kayıtlarıyla mutabakat yapılıyor.</p>
      <dl className="completion-check-grid">
        {rows.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}
      </dl>
      {check.blockers.length ? <div className="completion-check-blockers" role="alert"><strong>İş tamamlanamaz</strong>{check.blockers.map((blocker) => <span key={blocker}>{blocker}</span>)}</div> : null}
      <label className="touch-note"><span>Tamamlama notu <small>{check.requiresCompletionNote ? "Zorunlu" : "İsteğe bağlı"}</small></span><textarea autoFocus value={reason} onChange={(event) => setReason(event.target.value)} placeholder="Gerekliyse miktar farkını açıklayın" rows={3} /></label>
      <footer className="touch-form-actions"><button type="button" className="touch-cancel" onClick={close}>Vazgeç</button><button className="touch-save" disabled={saving || !check.canComplete || (check.requiresCompletionNote && !reason.trim())} onClick={() => void submit(reason.trim())}>{saving ? "Kaydediliyor…" : "Kontrolleri onayla ve tamamla"}</button></footer>
    </div>
  </Sheet>;
}
